import { render, staticRenderFns } from "./AdminBoxItem.vue?vue&type=template&id=eb69ce5a&scoped=true"
import script from "./AdminBoxItem.vue?vue&type=script&lang=js"
export * from "./AdminBoxItem.vue?vue&type=script&lang=js"
import style0 from "./AdminBoxItem.vue?vue&type=style&index=0&id=eb69ce5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb69ce5a",
  null
  
)

export default component.exports